export const EDIT_INTERVIEW = 'EDIT_INTERVIEW';

export const edit_interview = (stats: any) => ({
  type: EDIT_INTERVIEW,
  payload: stats
});